import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';

////////////////////////////////////////////////////////////// css

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

////////////////////////////////////////////////////////////// analytics

import { initAnalytics } from './analytics';

initAnalytics();

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <QueryClientProvider client={queryClient}>
    <ChakraProvider>
      <RouterProvider router={router} />
    </ChakraProvider>
  </QueryClientProvider>
);